import { inject, Injectable, NgModule, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { TranslationLanguagesEnum } from '@/common/translation/translation-languages-enum';

//used to omit loading all translation files, and only load ones required by a component + caching to avoid loading the same file multiple times
@Injectable({ providedIn: 'root' })
export class TranslationOrchestratorService {
	private readonly translationsLoaded = new Set<string>();

	private readonly translateService: TranslateService = inject(TranslateService);
	private readonly httpClient: HttpClient = inject(HttpClient);

	async load(scope: string, lang: TranslationLanguagesEnum): Promise<boolean> {
		const langString: string = lang.toString();
		const url = `assets/i18n/${scope}/${langString}.json`;

		try {
			if (!this.translationsLoaded.has(url)) {
				this.translationsLoaded.add(url);
				const data: Record<string, string> = await firstValueFrom(
					this.httpClient.get<Record<string, string>>(url),
				);
				this.translateService.setTranslation(langString, data, true);
			}
			this.translateService.use(langString);
		} catch {
			console.error(`[i18n] Brak pliku tłumaczeń dla: ${scope}/${langString}`);
			return false;
		}
		return true;
	}
}
